__turbopack_context__.v({
  "addButton": "OGDGZa_addButton",
  "addOnContainer": "OGDGZa_addOnContainer",
  "addOnDescription": "OGDGZa_addOnDescription",
  "addOnHeader": "OGDGZa_addOnHeader",
  "addOnInfo": "OGDGZa_addOnInfo",
  "addOnPrice": "OGDGZa_addOnPrice",
  "addOnTitle": "OGDGZa_addOnTitle",
  "parameter": "OGDGZa_parameter",
  "parameterSection": "OGDGZa_parameterSection",
  "parametersList": "OGDGZa_parametersList",
  "viewParametersButton": "OGDGZa_viewParametersButton",
});
